<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight] [current]="itemDetails?.title + ' sub cover item'" *ngIf="itemDetails?.title"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name={{filterValue}} [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
            <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
              <img src="../../../assets/img/filter.png" alt="filter"/>
            </button>
            <div class="filteringprt" *ngIf="isShowFilter">
              <form [formGroup]="filterForm">
              <h3 style="margin: 0;">Filter</h3>
              <mat-form-field appearance="outline">
                <mat-label>Search By</mat-label>
                <mat-select formControlName="searchBy">
                  <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Search Type</mat-label>
                <mat-select formControlName="searchType">
                  <mat-option *ngFor="let item of searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="btnprt">
                <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
                <button mat-button class="sub-button" (click)="filterChange()">Search</button>
              </div>
            </form>
            </div>
          </div>
        <div class="actions">
          <button class="create"  type="button" mat-mini-fab color="primary" (click)="navigateAddSubCoverdItem()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <table [dataSource]="dataSource" #dataTable mat-table>
            <!-- actions Column -->
            <ng-container matColumnDef="actions" stickyEnd>
                <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
                <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                    <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu"
                        (click)="$event.stopPropagation()">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                      <button mat-menu-item (click)="navigateSubCoverItemList(row?.planSubCoverItemId)">
                        <span>List of Sub Items</span>
                    </button>
                        <button mat-menu-item (click)="navigateEditSubCoverItem(row?.planSubCoverItemId)">
                            <span>Edit</span>
                        </button>
                        
                        <button mat-menu-item (click)="deleteCoveredItem('delete', row)">
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>Description</th>
                <td mat-cell *matCellDef="let element">
                    {{element?.description?.length > 50 ? (element?.description | slice:0:50)+'...' :
                    element?.description}}
                </td>
            </ng-container>
            <ng-container matColumnDef="averageCostForRepair">
                <th mat-header-cell *matHeaderCellDef>Average Cost For Repair</th>
                <td mat-cell *matCellDef="let element">
                    $ {{element?.averageCostForRepair ? (element?.averageCostForRepair | number) : 0}}
                </td>
            </ng-container>
            <ng-container matColumnDef="averageCostForReplacement">
                <th mat-header-cell *matHeaderCellDef>Average Cost For Replacement</th>
                <td mat-cell *matCellDef="let element">
                    $ {{element?.averageCostForReplacement ? (element?.averageCostForReplacement | number) : 0}}
                </td>
            </ng-container>
            <ng-container matColumnDef="commonIssues">
                <th mat-header-cell *matHeaderCellDef>Common Issues</th>
                <td mat-cell *matCellDef="let element">
                    {{element?.commonIssues}}
                </td>
            </ng-container>
            <ng-container matColumnDef="isActive">
              <th *matHeaderCellDef mat-header-cell>Status</th>
              <td *matCellDef="let row" mat-cell>
                  <mat-slide-toggle [(ngModel)]="row.isCovered" (change)="changeStatus($event, row)"></mat-slide-toggle>
              </td>
          </ng-container>
            <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="column.isModelProperty" [matColumnDef]="column.property">
                    <th *matHeaderCellDef mat-header-cell> {{ column.name }}</th>
                    <td *matCellDef="let row" mat-cell style="cursor:pointer">
                        {{ row[column.property] }}
                    </td>
                </ng-container>
            </ng-container>
            <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
            <tr *matRowDef="let row; columns: visibleColumns | paginate: { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount }"
                class="clickable route-animations-elements" mat-row>
            </tr>
            <div *cdkDragPlaceholder></div>
        </table>
        <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No Sub Coverage item found.
        </div>
       
        <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
        showFirstLastButtons
        [selectConfig] = "selectConfig"
        [ngClass]="{'mat-pegig': pageSize === 9999}"
        aria-label="Select page of periodic elements">
    </mat-paginator>
  
      </fury-list>
  
    </fury-page-layout-content>
</fury-page-layout>
  


